import { useSelector } from "react-redux";
import { selectOnlineOrdersConfigs } from "../../store/kitchen/kitchen.selector";
import { getColor } from "../../utils/utils.common";

const isDarkHex = (hexColor) => {
  if (!hexColor || typeof hexColor !== "string" || !hexColor.startsWith("#")) {
    return false;
  }
  const normalized =
    hexColor.length === 4
      ? `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
      : hexColor;
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance < 0.5;
};

const lightenHex = (hexColor, amount = 0.06) => {
  if (!hexColor || typeof hexColor !== "string" || !hexColor.startsWith("#")) {
    return hexColor;
  }
  const normalized =
    hexColor.length === 4
      ? `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
      : hexColor;
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  const mix = (value) =>
    Math.min(255, Math.round(value + (255 - value) * amount));
  return `#${mix(r).toString(16).padStart(2, "0")}${mix(g)
    .toString(16)
    .padStart(2, "0")}${mix(b).toString(16).padStart(2, "0")}`;
};

export const useMenuItemCardTheme = () => {
  const onlineOrdersConfig = useSelector(selectOnlineOrdersConfigs);
  const textBody = getColor("text-body", onlineOrdersConfig);
  const backgroundPrimary = getColor("background-primary", onlineOrdersConfig);
  const cardBackground = getColor("card-background", onlineOrdersConfig);
  const brandTertiary = getColor("brand-tertiary", onlineOrdersConfig);
  const isDarkTheme = isDarkHex(cardBackground || backgroundPrimary);
  const skeletonBase = lightenHex(cardBackground, 0.06);
  const skeletonHighlight = isDarkTheme
    ? "rgba(255, 255, 255, 0.18)"
    : "rgba(0, 0, 0, 0.06)";

  return {
    onlineOrdersConfig,
    textBody,
    backgroundPrimary,
    cardBackground,
    brandTertiary,
    skeletonBase,
    skeletonHighlight,
  };
};
